export const lo = {
  shared_components: {
    common: {
      back: "ກັບຄືນ",
      confirm_cancel: "ທ່ານແນ່ໃຈວ່າຈະຍົກເລີກບໍ?",
      current_executor: "ຜູ້ຮັບມອບໝາຍປັດຈຸບັນ: ",
      filter: "ຄົ້ນຫາ",
      inspector: "ຜູ້ກວດສອບ",
      load_more: "ເລື່ອນຂຶ້ນເພື່ອໂຫຼດເພີ່ມ...",
      no: "ບໍ່",
      organization_structure: "ອົງກອນ",
      please_enter: "ກະລຸນາປ້ອນ",
      please_select: "ກະລຸນາເລືອກ",
      reject: "ປະຕິເສດ",
      required_mark: "*",
      responsible_person: "ຜູ້ຮັບຜິດຊອບ",
      status: "ສະຖານະ",
      submit_date_end: "ວັນທີສົ່ງ (ເຖິງ)",
      submit_date_start: "ວັນທີສົ່ງ (ຈາກ)",
      yes: "ແມ່ນ",
      cancel: "ຍົກເລີກ",
      confirm: "ຢືນຢັນ",
      no_data: "ບໍ່ມີຂໍ້ມູນ",
      delete: "ລົບ",
      save: "ບັນທຶກ",
      submit: "ສົ່ງ",
      map_point: "MAP_POINT",
      view_floor_plan: "ເບິ່ງຜັງອາຄານ",
      can_multi_select: "ເລືອກໄດ້ຫຼາຍລາຍການ",
      choose_take_photo_msg: "ຖ່າຍຮູບ",
      project_cost_center_code: "ຫນ່ວຍຮັບຜິດຊອບ",
      project_name: "ອົງກອນຮັບຜິດຊອບ",
      choose: "ເລືອກ ",
      get_data_failed: "ດຶງຂໍ້ມູນບໍ່ສຳເລັດ!",
      go_back_key_img: "ກັບ",
      please_select_last_finding_category: "ກະລຸນາເລືອກໝວດໝູ່ຄວາມຄາດເຄື່ອນ/ຂໍ້ຄົ້ນພົບລະດັບສຸດທ້າຍ",
      floor_plan: "ແຜນຜັງຊັ້ນ"
    },
    add_inspection_object: {
      inspection_obj_add: "ເພີ່ມວັດຖຸການກວດສອບ",
      inspection_obj_input: "ກະລຸນາປ້ອນວັດຖຸການກວດສອບ",
      inspect_object_key: "ວັດຖຸການກວດສອບ",
      add_must: "ກະລຸນາເພີ່ມວັດຖຸການກວດສອບຢ່າງໜ້ອຍໜຶ່ງລາຍການ",
      other: "ອື່ນໆ"
    },
    corp_select: {
      please_select_last_location_for_inspection: "ກະລຸນາເລືອກສະຖານທີ່ກວດສອບລະດັບສຸດທ້າຍ"
    },
    filter_modals: {
      capa_code: "ເລກ CAPA",
      capa_exec_date: "ວັນທີກວດສອບ/ຮັບ",
      capa_final_verifier: "ຜູ້ຢືນຢັນຂັ້ນສຸດທ້າຍ",
      capa_finding_desc: "ຄຳອະທິບາຍຂໍ້ພົບ",
      capa_finding_evidence: "ຫຼັກຖານຂໍ້ພົບ",
      capa_finding_no: "ເລກທີຂໍ້ພົບ",
      capa_main_process: "ຂະບວນການຫຼັກ",
      capa_person_in_charge: "ຜູ້ຮັບຜິດຊອບ",
      capa_source: "ແຫຼ່ງ CAPA",
      capa_subject_title: "ຫົວຂໍ້ CAPA",
      capa_sub_process: "ຂະບວນການຍ່ອຍ",
      completion_date: "ວັນທີສິ້ນສຸດ",
      corrective_finished: "ການແກ້ໄຂສຳເລັດຫຼືບໍ່?",
      data_scope: "ຂອບເຂດຂໍ້ມູນ",
      ehsq_number: "ID ການປະເມີນ",
      end_time: "ວັນທີສິ້ນສຸດ",
      end_time_not_lg_start_time: "ເວລາສິ້ນສຸດບໍ່ສາມາດໜ້ອຍກວ່າເວລາເລີ່ມຕົ້ນ",
      evaluation_method: "KPI ຄວາມປອດໄພ",
      following_field: "ຟິລດ໌ຕໍ່ໄປນີ້ຈະຖືກສ້າງຂຶ້ນຫຼັງຈາກບັນທຶກແບບຟອມວຽກແລ້ວ",
      from: "(ຈາກ)",
      full_name: "ຊື່ ແລະ ນາມສະກຸນ",
      hazard_type: "ປະເພດອັນຕະລາຍ",
      help_center_doc_name: "ຊື່ເອກະສານ",
      immediate_check_category: "ປະເພດການກວດສອບ",
      incident_informant: "ຜູ້ແຈ້ງເຫດອຸບັດຕິການ",
      inspection_level: "INSPECTION_LEVEL",
      job_name: "ວຽກທີ່ກຳລັງປະຕິບັດ",
      locations: "ສະຖານທີ່",
      poba: "ສ່ວນຂອງຮ່າງກາຍທີ່ໄດ້ຮັບຜົນກະທົບ",
      project_id: "ID ໂຄງການ",
      project_name: "ຊື່ໂຄງການ",
      rate: "ການໃຫ້ຄະແນນ",
      reporting_department: "ພະແນກທີ່ລາຍງານ",
      responsibility_zone: "ພື້ນທີ່ຮັບຜິດຊອບ",
      audit_reviewer: "ຜູ້ທົບທວນ",
      start_time: "ວັນທີເລີ່ມຕົ້ນ",
      start_time_not_lg_end_time: "ເວລາເລີ່ມຕົ້ນບໍ່ສາມາດຫຼາຍກວ່າເວລາສິ້ນສຸດ",
      supplier_id: "ID ຜູ້ຮັບເໝົາ",
      target_finished: "ເປົ້າໝາຍສຳເລັດຫຼືບໍ່?",
      task_code: "ID ວຽກ",
      to: "(ເຖິງ)",
      unsafe_behavior: "ພຶດຕິກຳທີ່ບໍ່ປອດໄພ",
      unsafe_condition: "ສະພາບການທີ່ບໍ່ປອດໄພ",
      violation_item: "ໝວດໝູ່ຂໍ້ຄົ້ນພົບ",
      work_id_id: "ID ການປະຕິບັດງານ",
      work_name: "ຊື່ຂອງວຽກ",
      work_related: "ກ່ຽວຂ້ອງກັບວຽກ",
      id_number: "ເລກປະຈໍາຕົວ",
      incident_involved_person: "ຜູ້ເຂົ້າກ່ຽວ",
      incident_notifier_pro: "ຜູ້ຈັດການໂຄງການ",
      incident_reporting: "ລາຍງານເຫດການ",
      inspection_finding_category: "ໝວດໝູ່ຂໍ້ຄົ້ນພົບ",
      inspection_form: "ແບບຟອມການກວດສອບ",
      no: "ບໍ່",
      project_cost_center: "ອົງກອນ",
      project_name_bbs: "ອົງກອນຮັບຜິດຊອບ",
      reviewer: "ຜູ້ທົດສອບ",
      service_type: "ປະເພດບໍລິການ",
      submit_person: "ຜູ້ສ້າງ",
      verification_person: "ກວດສອບໂດຍ",
      yes: "ແມ່ນ",
      audit_type_display_key: "ປະເພດການກວດສອບ",
      business_line: "ສາຍທຸລະກິດ",
      cancel_button_key: "ຍົກເລີກ",
      check_table_table: "ຕາຕະລາງ",
      contractor_company: "ບໍລິສັດຜູ້ຮັບເໝົາ",
      contractor_personnel_id: "ID ບຸກຄະລາກອນ",
      corrective_action_title_key: "ການດຳເນີນການແກ້ໄຂ",
      due_date_end: "ວັນກຳນົດ (ເຖິງ)",
      due_date_start: "ວັນກຳນົດ (ຈາກ)",
      end_date: "ວັນສິ້ນສຸດ",
      incident_category: "ໝວດໝູ່ອຸບັດຕິການ",
      incident_location: "ສະຖານທີ່ເກີດອຸບັດຕິການ",
      incident_location_range: "ຂອບເຂດສະຖານທີ່",
      incident_organization: "ອົງກອນທີ່ຮັບຜິດຊອບ",
      inspection_date_end: "ວັນທີກວດກາ (ເຖິງ)",
      inspection_date_start: "ວັນທີກວດກາ (ຈາກ)",
      observer: "ຜູ້ສັງເກດການ",
      occupation: "ອາຊີບ",
      org_operation: "ພາກພື້ນ",
      report_date_key: "ວັນທີລາຍງານ",
      report_time: "ເວລາລາຍງານ",
      reset: "ຣີເຊັດ",
      schedule_name: "ຊື່ກຳນົດການ",
      area: "ພື້ນທີ່",
      project: "ໂຄງການ",
      years: "ປີ",
      report_start_time: "ວັນທີເລີ່ມຕົ້ນ",
      report_end_time: "ວັນທີສິ້ນສຸດ",
      audit_type: "ປະເພດການກວດປະເມີນ",
      search_view_task_no_key: "ລະຫັດງານ:",
      select_upper_org_structure: "ທ່ານຕ້ອງເລືອກໂຄງສ້າງອົງກອນລະດັບເທິງກ່ອນ",
      start_date: "ວັນເລີ່ມ",
      task_type: "ປະເພດການກວດສອບ",
      work_area: "ພື້ນທີ່ປະຕິບັດງານ",
      work_risk_level: "ລະດັບຄວາມສ່ຽງຂອງກິດຈະກຳ",
      working_area: "ພື້ນທີ່ເຮັດວຽກ",
      select_current_executor: "ເລືອກຜູ້ປະຕິບັດປັດຈຸບັນ",
      select_final_verifier: "ເລືອກຜູ້ຢືນຢັນຂັ້ນສຸດທ້າຍ",
      select_person_in_charge: "ເລືອກຜູ້ຮັບຜິດຊອບ",
      select_reporter: "ເລືອກຜູ້ລາຍງານ",
      select_reviewer: "ເລືອກຜູ້ກວດທານ",
      select_verifier: "ເລືອກຜູ້ຢືນຢັນ",
      incident_schedule: "ຄວາມຄືບໜ້າ",
      task_name: "ຊື່ໂຄງການ/ວຽກ",
      incident_subject: "ຫົວຂໍ້ອຸບັດຕິການ",
      accident_number: "ເລກອຸບັດເຫດ",
      select_capa_source: "ເລືອກແຫຼ່ງ CAPA",
      search_capa_source: "ຄົ້ນຫາແຫຼ່ງ CAPA",
      select_factory: "ເລືອກໂຮງງານ",
      search_factory: "ຄົ້ນຫາໂຮງງານ",
      search_employee: "ຄົ້ນຫາພະນັກງານ"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "ຍັງບໍ່ເລືອກພື້ນທີ່",
      please_mark_one_point_on_floor_plan: "ກະລຸນາຫມາຍຈຸດຫນຶ່ງຈຸດໃສ່ໃນແຜນຊັ້ນ",
      reset_zoom: "ຕັ້ງຄ່າຊູມໃໝ່",
      selected_areas: "ພື້ນທີ່ທີ່ເລືອກ"
    },
    image_annotator_modal: {
      arrow: "↗ ລູກສອນ",
      cancel: "ຍົກເລີກ",
      circle: "○ ວົງມົນ",
      clear: "✕ ລຶບທັງໝົດ",
      pen: "✏ ປາກກາ",
      pinch_zoom: "🤏 ຊູມດ້ວຍສອງນິ້ວ",
      rect: "□ ກ່ອງ",
      save: "ບັນທຶກໝາຍ",
      text_tool: "T ຂໍ້ຄວາມ",
      title_arrow: "ລູກສອນ",
      title_circle: "ວົງກົມ",
      title_pen: "ດິນສໍ",
      title_rect: "ສີ່ລ່ຽມ",
      title_reset_zoom: "ຣີເຊັດການຊູມ",
      title_text: "ຂໍ້ຄວາມ",
      undo: "↩ ຍ້ອນກັບ"
    },
    my_title: {
      homepage: "ໜ້າຫຼັກ",
      enterprise_wechat_exit_home_alert: "Enterprise Wechat ອອກຈາກໜ້າຫຼັກ"
    },
    no_source_img: {
      no_data: "ບໍ່ມີຂໍ້ມູນ"
    },
    org_select_modal: {
      choose_organization_structure: "ເລືອກອົງກອນ"
    },
    popover_dialog: {
      save_local: "ບັນທຶກຊົ່ວຄາວ"
    },
    return_dialog: {
      close_case: "ປິດ",
      invalid: "ບໍ່ຖືກຕ້ອງ"
    },
    select_picture: {
      choose_from_media_msg: "ເລືອກຈາກອະລະບັ້ມ",
      confirm_delete_msg: "ຢືນຢັນການລົບຫຼືບໍ?",
      get_image_fail: "ບໍ່ສາມາດຮັບຮູບພາບໄດ້"
    },
    select_picture_new: {
      attachement_download_fail: "ດາວໂຫຼດໄຟລ໌ແນບລົ້ມເຫຼວ",
      be_uploading: "ກຳລັງອັບໂຫຼດ",
      cancel_key: "ຍົກເລີກ",
      load_from_gallery: "ໂຫຼດຈາກຄັງຮູບ",
      select_image_source: "ເລືອກແຫຼ່ງຮູບພາບ",
      use_camera: "ໃຊ້ກ້ອງ",
      use_file: "ໂຫຼດຈາກໄຟລ໌",
      camera_access_denied: "ການເຂົ້າເຖິງກ້ອງຖືກປະຕິເສດ. ກະລຸນາເປີດໃນການຕັ້ງຄ່າລະບົບ.",
      camera_not_found: "ບໍ່ພົບກ້ອງໃນອຸປະກອນນີ້"
    },
    spinner: {
      data_load_msg: "ກຳລັງໂຫຼດຂໍ້ມູນ ກະລຸນາລໍຖ້າ..."
    },
    svg: {
      top: "ດ້ານເທິງ"
    },
    turn_to_send: {
      mission_assign_success: "ໂອນວຽກສຳເລັດ",
      report_member: "ສະມາຊິກທີມສອບສວນ",
      select_mission_assignee_msg: "ກະລຸນາເລືອກຜູ້ຮັບໂອນວຽກ!",
      turn_to_send: "ມອບຫາມຽນ",
      turn_to_send_to: "ມອບຫາມຽນວຽກໃຫ້",
      project_cost_center_code: "ລະຫັດສູນຕົ້ນທຶນໂຄງການ"
    },
    select_file: {
      unsupported_format_desktop_only: "ຮູບແບບໄຟລ໌ແນບນີ້ຍັງບໍ່ຮອງຮັບ, ກະລຸນາເບິ່ງທາງຄອມພິວເຕີ.",
      format_not_supported: "ຮູບແບບໄຟລ໌ນີ້ບໍ່ຮອງຮັບການເບິ່ງແບບອອນໄລນ໌ ກະລຸນາໃຊ້ອິນເຕີເຟຊບົນເວັບເພື່ອດາວໂຫລດ ແລະ ເປີດເບິ່ງ"
    },
    fabric_canvas: {
      please_select_first: "ບໍ່ມີວັດຖຸທີ່ຖືກເລືອກ. ກະລຸນາເລືອກວັດຖຸກ່ອນ.",
      delete_current_instance_only: "ລຶບອອກລົ້ມເຫລວ. ທ່ານສາມາດລຶບໄດ້ສະເພາະຮູບແຕ້ມທີ່ກ່ຽວຂ້ອງກັບສະຖານທີ່ນີ້ເທົ່ານັ້ນ."
    }
  }
};
